import store from '..';
import { CronTasks } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const {
    initialState, resetReducer,
    getReducer, listReducer, updateReducer, duplicateReducer,
    startCreateReducer, createReducer, deleteReducer,
    resetAction, getAction, listAction, updateAction, duplicateAction,
    startCreateAction, createAction, deleteAction
} = createRestSlices(CronTasks);

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        resetReducer,
        getReducer, listReducer, updateReducer, duplicateReducer,
        startCreateReducer, createReducer, deleteReducer
    ]);
}

/* Export CRUD actions */
export const resetCronTasks      = resetAction;
export const startCreateCronTask = startCreateAction;
export const createCronTask      = createAction;
export const loadCronTask        = getAction;
export const loadCronTasks       = listAction;
export const updateCronTask      = updateAction;
export const deleteCronTask      = deleteAction;
export const duplicateCronTask   = duplicateAction;
